import { useCallback } from "react";
import { axiosStructurePartner } from "./axios";

export const useDeleteStructurePartner = () => {
  const [state, execute, cancel] = axiosStructurePartner<void, unknown>(
    {
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string) => {
      return execute({ url: id });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
